export enum MediaManagerSpecialFolderId {
  // Backend-defined special top-level folder IDs.
  PosMedia = 'POS_MEDIA',
  PosAssets = 'POS_ASSETS'
}

export const mediaManagerSpecialFolderDisplayNames: Record<MediaManagerSpecialFolderId, string> = {
  [MediaManagerSpecialFolderId.PosMedia]: 'POS Media',
  [MediaManagerSpecialFolderId.PosAssets]: 'POS Assets'
};

export const mediaManagerSpecialTopLevelFolderIds: ReadonlySet<string> = new Set([
  MediaManagerSpecialFolderId.PosMedia,
  MediaManagerSpecialFolderId.PosAssets
]);

/**
 * Backend-seeded top-level folders present on every brand media library. They are ordinary asset-library folders
 * except for their sentinel ids, so the id is the only contract that marks one as immutable. Kept apart from
 * `mediaManagerSpecialTopLevelFolderIds` on purpose: that set drives `isWithinSpecialFolder`, which locks an
 * entire subtree, and brand system folders must still accept sub-folders and uploads.
 */
export enum MediaManagerBrandSystemFolderId {
  Logo = 'BRAND_LOGO',
  Facility = 'BRAND_FACILITY',
  Marketing = 'BRAND_MARKETING',
  Educational = 'BRAND_EDUCATIONAL'
}

/** Pill display order for the brand system folders. User-created top-level folders sort after these, by name. */
export const mediaManagerOrderedBrandSystemFolderIds: readonly string[] = [
  MediaManagerBrandSystemFolderId.Logo,
  MediaManagerBrandSystemFolderId.Facility,
  MediaManagerBrandSystemFolderId.Marketing,
  MediaManagerBrandSystemFolderId.Educational
];
